<template>
  <div>
    <SearchComponent
      :isAdd="true"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      @on-add="add"
      :authIdentity="authIdentity"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :total="total"
      :tableData="tableData"
      :pageParams="queryParams"
      @pageChange="handleSearch"
    >
      <template slot="solts" slot-scope="scope">
        <el-button
          v-hasPermi="[authIdentity + ':edit']"
          class="button"
          type="text"
          size="small"
          @click="handleUpdata(scope.data, scope.$index)"
          >修改</el-button
        >
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          class="button"
          type="text"
          size="small"
          @click="handleSee(scope.data, scope.$index)"
          >详情</el-button
        >
        <el-button
          v-hasPermi="[authIdentity + ':del']"
          class="delbutton"
          type="text"
          size="small"
          @click="handleDel(scope.data, scope.$index)"
          >删除</el-button
        >
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="cancel"
    >
      <component ref="myform" :is="currentView" :type="type"></component>
      <span slot="footer" v-if="type !== 'preview'">
        <el-button class="batch-button" @click="cancel">取 消</el-button>
        <el-button class="line-button" @click="submitForm" :loading="submitLoading">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import myform from './components/Form'
import {
  getProcessFactoryList,
  getProcessFactory,
  delProcessFactory,
  addProcessFactory,
  updateProcessFactory,
} from '@/api/manage/process-factory'
export default {
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
  },
  data() {
    const _this = this
    return {
      authIdentity: 'library:factory',

      submitLoading: false,

      dialogVisible: false,
      title: '',
      currentView: '',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      type: '',

      colLists: [
        {
          prop: 'name',
          label: '加工厂名称',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'ownerName',
          label: '联系人',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'ownerContact',
          label: '联系方式',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'locDetails',
          label: '加工厂地址',
          isTrue: true,
          align: 'left',
          formatter(row) {
            const preLocal =
              row.cnProvinceName === row.cnCityName
                ? row.cnProvinceName + row.cnDistrictName
                : row.cnProvinceName + row.cnCityName + row.cnDistrictName
            return preLocal + (row.locDetails || '')
          },
        },
        {
          prop: 'createTime',
          label: '创建时间',
          isTrue: true,
          formatter(row) {
            return _this.parseTime(row.createTime, '{y}-{m}-{d}')
          },
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
      tableData: [],
      selectOrInputList: [
        {
          model: 'name',
          placeholder: '请输入工厂名称',
          class: 'home',
          type: 'input',
        },
      ],
    }
  },
  created() {
    this.getProcessFactoryList()
  },
  methods: {
    handleDel({ id, name, ownerBizPartnerId }) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        delProcessFactory({ 
          id, 
          name, 
          ownerBizPartnerId, 
          type: 2, //1:客户,2:供应商,3:当前企业  
        }).then((response) => {
          if (response.code == 200 && response.flag) {
            this.$message.success(`操作成功！`)
            this.getProcessFactoryList()
          } else {
            this.$message.error(response.message)
          }
        })
      })
    },
    async submitForm() {
      console.log('进来')
      this.submitLoading = true
      try {
        const formData = await this.$refs.myform.submit(this.type)
        if (this.type == 'add') {
          const res = await addProcessFactory(formData)
          if (!res.flag) {
            this.$message.error(res.message)
            return Promise.reject(res.message)
          }
          this.$message.success('新增成功')
        } else if (this.type == 'edit') {
          const res = await updateProcessFactory(formData)
          if (!res.flag) {
            this.$message.error(res.message)
            return Promise.reject(res.message)
          }
          this.$message.success('修改成功')
        }
        this.dialogVisible = false
        this.getProcessFactoryList()
      } catch (err) {
        console.log(err)
      } finally {
        this.submitLoading = false
      }
    },
    cancel() {
      this.dialogVisible = false
    },
    add() {
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        this.title = '新增加工厂'

        this.type = 'add'
        this.$refs.myform.add(this.type)
      })
    },
    handleSee(row) {
      getProcessFactory({ id: row.id })
        .then((res) => {
          if (res.flag) {
            let data = res.data
            this.dialogVisible = true
            this.title = '查看加工厂'
            this.currentView = 'myform'
            this.type = 'preview'
            this.$nextTick(() => {
              this.$refs.myform.getDetail(data, this.type)
            })
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleUpdata(row) {
      getProcessFactory({ id: row.id })
        .then((res) => {
          if (res.flag) {
            let data = res.data
            data.parentFullCodeList = res.data.parentFullCodeList
            data.name = res.data.name
            data.parentFullName = res.data.parentFullName
            data.level = res.data.level
            data.id = res.data.id
            data.level = 6
            this.dialogVisible = true
            this.currentView = 'myform'
            this.type = 'edit'
            this.title = '修改加工厂'
            console.log(data, 'datadatadata-------------------------------------------')
            this.$nextTick(() => {
              this.$refs.myform.getDetail(data)
            })

            // this.formData.parentFullCodeList = res.data.parentFullCodeList
            // this.formData.name = res.data.name
            // this.formData.parentFullName = res.data.parentFullName
            // this.formData.level = res.data.level
            // this.formData.id = res.data.id
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })

      // this.$nextTick(() => {
      //   this.title = '修改行政区域管理'
      //   console.log(that.$refs.myform, ' this.$refs.my111111111111form.getDetail------------')
      //   this.$refs.myform.getDetail(row)

      //   this.type = 'edit'
      // })
    },
    handleFence(row) {
      console.log('围明细')
      console.log(row, 'row')
      this.$router.push({
        path: '/fence',
        query: {
          parentId: row.id,
          name: row.name,
          parentFullName: row.parentFullName,
          parentFullCodeList: row.parentFullCodeList,
          code: row.code,
        },
      })
    },
    getProcessFactoryList() {
      getProcessFactoryList({
        ...this.queryParams,
        type: 2, //1:客户,2:供应商,3:当前企业
      })
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items
            this.total = res.data.totalCount
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleSearch(data) {
      console.log(data, '----------------------')
      if (data) {
        for (let key in data) {
          this.queryParams[key] = data[key]
        }
      }
      this.queryParams.pageNum = 1

      this.getProcessFactoryList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
      }
      this.getProcessFactoryList()
    },
  },
}
</script>
<style scoped lang="less">
@import '~@/assets/tableList.less';
// @import '../../../../assets/form.less';
/deep/ .el-button--text {
  font-size: 14px;
}
</style>
